import axios from "axios";
import useSWR from "swr";
import { basicFetcher } from "utils/fetcher";

export function useLikes() {
  return useSWR<{ data: Product[] }>("users/my-favourites", basicFetcher, {
    isPaused() {
      return !axios.defaults.headers.common.Authorization;
    },
    errorRetryCount: 0,
    shouldRetryOnError: false,
  });
}
